function convertToCurrencyOfPrice(amount) {
  return "$" + (amount / 100).toFixed(2);
}

let allLifestyleSelect = document.querySelectorAll(".lifestyleVariantOptions");

allLifestyleSelect.forEach((each) => {
  each.addEventListener("change", (event) => {
    let parentCLP = each.closest(".custom-lifestyle-product");
    let productHandle = each.dataset.handle;

    fetch("/products/" + productHandle + ".js")
      .then((response) => response.json())
      .then((data) => {
        let productVariants = data.variants;
        console.log("event",event)
        parentCLP.querySelector(".quickAddBtn").dataset.atc =  event.target.value;
        parentCLP.querySelector(".quickAddBtn").dataset.selection =  event.target.selectedOptions[0].innerText

        productVariants.forEach((eachVariant) => {
          const {
            name: titleOfVariant,
            id,
            price,
            compare_at_price,
            featured_image: { src: srcOfVariant },
          } = eachVariant;

          if (id == event.target.value) {
            parentCLP.querySelector(".clp-title").innerHTML = titleOfVariant;
            parentCLP.querySelector(".clp-price").innerHTML =
              convertToCurrencyOfPrice(price);
            if (parentCLP.querySelector(".clp-price-before")) {
              parentCLP.querySelector(".clp-price-before").innerHTML =
                convertToCurrencyOfPrice(compare_at_price);
            }
            if (srcOfVariant) {
              parentCLP.querySelector(".clp-image").src = srcOfVariant;
            }
          }
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
});
